import { base } from '../airtable-config.js';

export async function fetchMitacsInstitutions() {
  return base('MitacsInstitutions').select({ view: 'Grid view' }).all();
}
